"use client";

import { MapPinIcon } from "@heroicons/react/24/solid";
import { AddressBlock } from "@/payload-types";
import dynamic from "next/dynamic";
import { useMemo } from "react";

type ItemFromAddress = NonNullable<AddressBlock["addresses"]>[number];

export default function AgencyLocalisation({
  address,
}: {
  address: ItemFromAddress;
}) {
  const Map = useMemo(
    () =>
      dynamic(() => import("@onclicks/sharedcomponents/ui/LeafletMap"), {
        loading: () => <p>Une carte est en cours de chargement</p>,
        ssr: false,
      }),
    [],
  );

  return (
    <>
      <h3 className="mt-6 text-2xl font-bold tracking-tight text-gray-600">
        {address.titleAddress}
      </h3>
      <dl className="mt-6 space-y-4 text-base leading-7 text-gray-600">
        <div className="flex gap-x-4">
          <dt className="flex-none">
            <span className="sr-only">Adresse</span>
            <MapPinIcon className="h-7 w-6 text-[#009EE2]" aria-hidden="true" />
          </dt>
          <dd>
            {address.googleLink && (
              <a href={address.googleLink} target="_blank" rel="nofollow">
                {address.number} {address.street},
                <br />
                {address.postalCode} {address.locality}
              </a>
            )}
          </dd>
        </div>
      </dl>
      <Map
        latitude={String(address.latitude ?? 0)}
        longitude={String(address.longitude ?? 0)}
      />
    </>
  );
}
